import {Box} from "@chakra-ui/react";
import Footer from '../../layouts/Footer';
import Header from '../../layouts/Header';
import ClaimSPTokenBody from '../../components/ClaimSPTokenBody';

const ClaimSPToken = (props) => {

	return(
		<Box>
      <Header />
			<ClaimSPTokenBody params={props.claimsptoken}/>
      <Footer />
		</Box>
	)
}

export default ClaimSPToken;